<div class="container-fluid">

  <button class="q-btn q-main mr-2" [disabled]="!validation()" (click)="enregistrerMFA()" title="{{txtToolTip}}">
    <i [ngClass]="[SaveInprogress ? 'fas fa-spinner fa-spin fa-pulse ml-2' : 'fas fa-save ml-2']"></i>
    <span class="ml-1 mr-2">{{txtEnregistrer}}</span>
  </button>
  <i class="q-c-main fas fa-exclamation-circle mr-2" title="{{txtInfo}}"></i>
  <div class="row no-gutters justify-content-between ">
    <div class="q-default col-12 col-md-6 facturation-card mt-4">

      <div class="row no-gutters align-items-center">
        
        <p class="ml-2"><i class="q-c-main fas fa-money-bill mr-2"  style="font-size: 25px;"></i><span class="q-bold mr-2">{{'modeDeFacturation' | trad}}</span></p>
      </div>

      <div class="row no-gutters">
        <div class="col-6">

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'entite' | trad}}: </label>
            <div class="col-11 " [ngClass]="{'error-input': !isEntite}">
              <select (change)="getEntite($event)" class="q-input-required q-main-select w-100 input q-main-focus">
                <option *ngFor="let entite of modeFacturationDisplay.entite"
                        [selected]="entite.id === modeFacturation.entiteFacturation.id"
                        [value]="entite.id">
                  {{entite.value}}
                </option>
              </select>
            </div>
            <small *ngIf="!isEntite" class="error w-100 ">{{'entiteNoValid' | trad}} {{userEntiteBloquee}}</small>
          </div>

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'groupe' | trad}}: </label>
            <div class="col-11 " [ngClass]="{'error-input': !isGroupe}">
              <select (change)="getGroupe($event)" class="q-input-required q-main-select w-100 input q-main-focus">
                <option *ngFor="let groupe of modeFacturationDisplay.groupeFacturation"
                        [selected]="groupe.id === modeFacturation.groupeFacturation.id"
                        [value]="groupe.id">
                  {{groupe.value}}
                </option>
              </select>
            </div>
            <small *ngIf="!isGroupe" class="error w-100 ">{{'groupeNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'famille' | trad}}: </label>
            <div class="col-11 ">
              <select (change)="getGroupeFamille($event)" class="q-main-select w-100 input q-light-main-focus">
                <option *ngFor="let groupeFamille of modeFacturationDisplay.groupeFamille"
                        [selected]="groupeFamille.id === modeFacturation.groupeFamille.id"
                        [value]="groupeFamille.id">
                  {{groupeFamille.value}}
                </option>
              </select>
            </div>
          </div>

          <div class="row no-gutters mt-2" [title]="modeFacturation.article.title">
            <label class="w-100">{{'article' | trad}}: </label>
            <div *ngIf="modeFacturationDisplay.article.length > 0" class="col-11 " [ngClass]="{'error-input': !isArticle}">
              <select (change)="getGroupeArticle($event)" class="q-main-select w-100 input q-input-required q-main-focus">
                <option *ngFor="let article of modeFacturationDisplay.article"
                        [selected]="article.id === modeFacturation.article.id"
                        [value]="article.id"
                        [title]="article.title">
                  {{article.value}}
                </option>
              </select>
            </div>
            <small *ngIf="!isArticle" class="error w-100 ">{{'articleNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'ordredeslignes' | trad}}: </label>
            <div class="col-11 ">
              <select (change)="getOrdreLigne($event)" class="q-main-select w-100 input q-light-main-focus">
                <option *ngFor="let ordre of modeFacturationDisplay.ordreLigne"
                        [selected]="ordre.id === modeFacturation.ordreLigne.id"
                        [value]="ordre.id">
                  {{ordre.value}}
                </option>
              </select>
            </div>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'groupedelignes' | trad}}: </label>
            <div class="col-11 ">
              <select (change)="getGroupeLigne($event)" class="q-main-select w-100 input q-light-main-focus">
                <option *ngFor="let groupe of modeFacturationDisplay.groupeLigne"
                        [selected]="groupe.code === modeFacturation.groupeLigne.code"
                        [value]="groupe.code">
                  {{groupe.value}}
                </option>
              </select>
            </div>
          </div>

        </div>
        <div class="col-6">


          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'datePremiereEmission' | trad}}: </label>
            <div class="q-input-required q-date col-11 " [style.height]="'30px'">
              <input type="date" max="9999-12-31" class="q-input-required q-main-focus"
                     [(ngModel)]="dateF"
                     (blur)="FormatDateDebutFacturationToShort($event.target.value);" />
            </div>
            <small *ngIf="!isDateDebut" class="error w-100">{{'DateNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">Date de l'échéancier de facturation: </label>
            <div class="row no-gutters align-items-center mt-1">
              <p class="mr-2">{{'dateEmission' | trad}}</p>
              <div id="switch" class="checkbox checbox-switch switch-primary">
                <label class="q-pointer">
                  <input class="input" type="checkbox" [checked]="modeFacturation.facturationFindemois" (change)="checkFinMois($event.target.checked)" />
                  <span></span>
                </label>
              </div>
              <p class="ml-1">{{'finDeMois' | trad}}</p>
            </div>
          </div>


          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'modeDeCalcul' | trad}}: </label>
            <div class="row no-gutters align-items-center mt-1">
              <p class="mr-2">{{'forfait' | trad}}</p>
              <div id="switch" class="checkbox checbox-switch switch-primary">
                <label class="q-pointer">
                  <input class="input" type="checkbox" [checked]="modeFacturation.type === 2" (change)="checkType($event.target.checked)" />
                  <span></span>
                </label>
              </div>
              <p class="ml-1">{{'timeSpent' | trad}}</p>
            </div>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'nbreFacture' | trad}}: </label>
            <div class="col-11 ">
              <input class="form-control input q-input-no-border w-100 q-input-required q-main-focus" type="number" min="1" [(ngModel)]="modeFacturation.nbreOccurence" (keyup)="changeNbOccur($event.target.value)" [ngClass]="{'error-input': !isEcheance}">
            </div>
            <small *ngIf="!isEcheance" class="error w-100">{{'echeanceNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">Périodicité des factures: </label>
            <div class="col-11 ">
              <select (change)="getPeriodicite($event)" class="q-main-select w-100 input q-input-required q-main-focus">
                <option *ngFor="let periodicite of modeFacturationDisplay.typePeriodicite"
                        [selected]="periodicite.id === modeFacturation.periodicite.id"
                        [value]="periodicite.id">
                  {{periodicite.value}}
                </option>
              </select>
            </div>
            <!-- <small *ngIf="!isPeriodicite" class="error w-100">Periodicité non valide</small> -->
          </div>

        </div>
      </div>
    </div>

    <div class="q-default col-12 col-md-5 facturation-card mt-4">

      <div class="row no-gutters align-items-center">        
        <p class="ml-2"><i class="q-c-main fas fa-money-check mr-2" style="font-size: 25px;"></i><span class="q-bold">{{'modeReglement' | trad}}</span></p>
      </div>

      <div class="row no-gutters ">
        <div class="col-12">

          <div class="row no-gutters align-items-center  mt-2">
            <label class="w-100">{{'datePremiereEcheance' | trad}}: </label>
            <label class="form-control input q-light-grey q-input-no-border w-100 col-8" style="font-size:.875rem;">{{dateR}}</label>
          </div>

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'delaiReglement' | trad}}: </label>
            <div class="row no-gutters align-items-center mt-1">
              <p class="mr-2">{{'dateEmission' | trad}}</p>
              <div id="switch" class="checkbox checbox-switch switch-primary">
                <label class="q-pointer">
                  <input class="input" type="checkbox" [checked]="modeFacturation.reglementMoisPlus1" (change)="checkChange($event.target.checked)" />
                  <span></span>
                </label>
              </div>
              <p class="ml-1">{{'finDeMois' | trad}}</p>
            </div>
          </div>

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'nbJour' | trad}}: </label>
            <div class="col-8 ">
              <input class="form-control input q-input-no-border w-100 q-input-required q-main-focus" type="number" [(ngModel)]="modeFacturation.jourReglement" (keyup)="changeDay($event.target.value)" [ngClass]="{'error-input': !isNbJour}">
            </div>
            <small *ngIf="!isNbJour" class="w-100 error">{{'nbJourNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters align-items-center mt-2">
            <label class="w-100">{{'byType' | trad}}: </label>
            <div class="col-8 " [ngClass]="{'error-input': !isModeReglement}">
              <select (change)="getModeReglement($event)" class="q-main-select w-100 input q-input-required q-main-focus">
                <option *ngFor="let modeReglement of modeFacturationDisplay.modeReglement"
                        [selected]="modeReglement.id === modeFacturation.modeReglement.id"
                        [value]="modeReglement.id">
                  {{modeReglement.value}}
                </option>
              </select>
            </div>
            <small *ngIf="!isModeReglement" class="w-100 error">{{'modeReglementNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'nbEcheance' | trad}}: </label> <!--nombres d'echéance/facture-->
            <div class="col-8 ">
              <input class="form-control input q-input-no-border w-100 q-input-required q-main-focus" type="number" min="1" [(ngModel)]="modeFacturation.nbreOccurenceReglement" (keyup)="changeNbOccurReg($event.target.value)" [ngClass]="{'error-input': !isOccurenceReglement}">
            </div>
            <small *ngIf="!isOccurenceReglement" class="w-100 error">{{'occuranceNoValid' | trad}}</small>
          </div>

          <div class="row no-gutters mt-2">
            <label class="w-100">{{'periodiciteEcheance' | trad}}: </label>
            <div class="col-8 ">
              <select (change)="getPeriodiciteReglement($event)" class="q-main-select w-100 input q-input-required q-main-focus">
                <option *ngFor="let periodicite of modeFacturationDisplay.typePeriodicite"
                        [selected]="periodicite.id === modeFacturation.periodiciteReglement.id"
                        [value]="periodicite.id">
                  {{periodicite.value}}
                </option>
              </select>
            </div>
            <!-- <small *ngIf="!isPeriodiciteReglement" class="w-100 error">Périodicité de règlement non valide</small> -->
          </div>

        </div>
      </div>
    </div>
  </div>


</div>
